import { render, staticRenderFns } from "./mainPage.vue?vue&type=template&id=1db6f985&"
import script from "./mainPage.vue?vue&type=script&lang=js&"
export * from "./mainPage.vue?vue&type=script&lang=js&"
import style0 from "./mainPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports